import React from "react"

export const ComponentLoader = () => {
    return (
        <div className="expertise">
            <div className="container">
                <div className="row">
                    <div className="content-loading">
                        <div className="loading2">
                            <div className="loader2">Loading...</div>
                        </div>
                    </div>                 
                </div>
            </div>
        </div>
    )
}

export const GeneralLoader = () => {
    return (
        <div className="content-loading-home">
            <div className="loading2">
                <div className="loader2">Loading...</div>
            </div>
        </div> 
    )
}

export default GeneralLoader;